import { EmployeeFormOptions } from '../types/EmployeeTypes';
import { useGetEmployeeFormOptionsQuery } from '@/common/infrastructure/gql/generated/schema';

export const useGetEmployeeFormOptions = ({ skip }: { skip: boolean }) => {
  const { data, loading, error } = useGetEmployeeFormOptionsQuery({ skip });

  const formOptions = data?.supportingEmployeeDataQuery?.value as EmployeeFormOptions | null | undefined;

  return {
    formOptions,
    loading,
    error,
    availableJobRoles: formOptions?.availableJobRoles ?? [],
    availableEmploymentStatuses: formOptions?.availableEmploymentStatuses ?? [],
    availableDispatchLocations: formOptions?.availableDispatchLocations ?? [],
    availableWorkLocations: formOptions?.availableWorkLocations ?? [],
    availableOutOfOfficeReasons: formOptions?.availableOutOfOfficeReasons ?? []
  };
};
